import React, { useEffect, useState } from 'react';
import WhatIncludes from 'containers/Payment/WhatIncludes';
import { useSelector, useDispatch } from 'react-redux';

import { useGetPlanSelectorInfo } from 'hooks/useGetPlanSelectorInfo';
import { checkIfProtectPaymentIsActive } from 'containers/EPG/actions/channelBlocker/blocker.actions';
import { createSearchParams, useLocation, useNavigate } from 'react-router-dom';

export const getParameterByName = (name, url) => {
  const newName = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${newName}(=([^&#]*)|&|#|$)`);

  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const WhatIncludesContainerPlanSelector = () => {
  const translations = useSelector(state => state.translations);
  const assets = useSelector(state => state.asset);
  const location = useLocation();
  const navigate = useNavigate();
  const { handleCardClickWhatIncludes } = useGetPlanSelectorInfo() || {};
  const workflowStart = useSelector(state => state?.payway?.workflowStart);
  const user = useSelector(state => state.user);
  const { offersSelect, paramPaymet, linkPayment } = useSelector(
    state => state?.modalLandingCommercial,
  );
  const dispatch = useDispatch();
  const [isClick, setIsClick] = useState(false);

  useEffect(
    () => {
      if (
        workflowStart.inProgress === false &&
        linkPayment && // que venga la url
        isClick
      ) {
        if (workflowStart?.success) {
          setIsClick(false);
          dispatch(
            checkIfProtectPaymentIsActive({
              onSuccess: () =>
                navigate(linkPayment, {
                  search: `?${createSearchParams(paramPaymet)}`,
                  state: {
                    screen:
                      getParameterByName(
                        'selected_payment_method',
                        offersSelect?._links?.checkout?.href,
                      ) === 'promogate'
                        ? 'promogate'
                        : 'checkout',
                  },
                }),
            }),
          );
        }
      }
    },
    [workflowStart.inProgress, linkPayment],
  );

  const handleClick = (plan, e) => {
    e.stopPropagation();
    setIsClick(true);
    handleCardClickWhatIncludes(plan);
  };

  return (
    <WhatIncludes
      translations={translations}
      assets={assets}
      location={location}
      handleClick={(planArg, e) => {
        handleClick(planArg, e);
      }}
    />
  );
};
